import React from 'react';

import { CustomAttributeData } from '../../../customAttributes/customAttributes';

interface ComponentCustomAttributeTextProps {
  attribute: CustomAttributeData,
  value: string,
  onValueChanged: (updatedValue: string) => void,
  editable: boolean
}

export function ComponentCustomAttributeText({
  attribute,
  value,
  onValueChanged,
  editable,
}: ComponentCustomAttributeTextProps): JSX.Element {

  if (attribute.propertiesText === undefined) {
    return <div />;
  }

  return (
    <>
      <div className="col-3">
        <b style={{ color: attribute.color || '#000000' }}>{attribute.name}</b>
      </div>
      <div className="col-9">
        <input
          style={{
            width: '100%',
          }}
          type="text"
          id={attribute.key}
          name={attribute.name}
          maxLength={attribute.propertiesText.maxLength}
          value={value}
          onChange={(event) => onValueChanged(event.target.value)}
          readOnly={!editable}
        />
      </div>
    </>
  );
}
